export default "__VITE_ASSET__BeIdaunx__"